import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { QueryPanelContentMessage } from '../models/messages/query-panel-messages';

@Injectable({
  providedIn: 'root'
})

// Shared service for the right hand side of a isg-query-panel.
// It's used to communicate between the treeview components, the criteria control
// at the top of the panel, and the search box.
export class QueryPanelContentConnectorService {
  /*-------------------------- private variables --------------------------*/
  private subject = new Subject<QueryPanelContentMessage>();

  /*-------------------------- public functions --------------------------*/

  public export(criteria: any, title: string, headerLines: string[]) {
    var msg = new QueryPanelContentMessage();
    msg.criteria = criteria;
    msg.headerLines = headerLines;
    msg.title = title;
    msg.type = "export";
    this.subject.next(msg);
  }

  public search(criteria: any) {
    var msg = new QueryPanelContentMessage();
    msg.criteria = criteria;
    msg.type = "search";
    this.subject.next(msg);
  }

  public onMessage(): Observable<QueryPanelContentMessage> {
    return this.subject.asObservable();
  }
}
